import React, { useState, useEffect } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

// `onBack` (optional): when supplied, the header's back arrow runs this instead
// of going back in history. Used by screens with an in-page drill-down (e.g. the
// grouped Income-Tax e-proceedings, where the arrow returns to the group cards).
// Omitted everywhere else, so existing pages keep the plain navigate(-1).
const PageTitle = ({ title, onBack }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-gradient-to-r from-blue-900 to-blue-600 text-white p-4 flex items-center justify-center relative shadow-md">
      <button
        onClick={() => {
          if (typeof onBack === "function") {
            onBack();
            return;
          }
          navigate(-1);
        }}
        className="absolute left-4 text-white text-xl hover:text-gray-200 transition cursor-pointer exempt-from-readonly"
      >
        <FaArrowLeft />
      </button>
      <h1 className="text-2xl font-bold">{title}</h1>
    </header>
  );
};

export default PageTitle;
